import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { DialogModule } from 'primeng/dialog';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { ButtonModule } from 'pu-core-library';

@Component({
  standalone: true,
  selector: 'app-info-modal',
  imports: [DialogModule, ButtonModule],
  templateUrl: './info-modal.component.html',
  styleUrl: './info-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InfoModalComponent implements OnInit {
  text!: string;

  constructor(private dynamicDialogConfig: DynamicDialogConfig) {}

  ngOnInit(): void {
    if (this.dynamicDialogConfig && this.dynamicDialogConfig.data) {
      this.text = this.dynamicDialogConfig.data.text;
    }
  }
}
